export default __webpack_public_path__ + "static/menu-tachibanaudon-min4-44bc33c64fe3411a8cda39468f62aa15.jpg";